import React, { Component } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import Currency from "react-currency-formatter";


import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBInput,
    MDBRow,
    MDBTypography,
  } from "mdb-react-ui-kit";

const SliderContainer = tw.div`m-0 p-0`;

export default class PreviousNextMethods extends Component {
    constructor(props) {
      super(props);
    
    //   this.state = {
    //     slide: 0,
    //     quantity: 0
    //   }

      this.next = this.next.bind(this);
      this.previous = this.previous.bind(this);
    }    

    /* setSlide(currentSlide) {
        console.log(currentSlide)
        this.setState({...this.state, slide: currentSlide})
    } */

    next() {
      this.slider.slickNext();
    }
    previous() {
      this.slider.slickPrev();
    }
    render() {

        const changeSlide = (currentSlide) => {
            this.props.setMeasureIndex(currentSlide)
        }

        const increment = () => {
            if (this.props.quantity >= 0) {
                this.props.setQuantity(Number(this.props.quantity) + 1)
            } else return
            
        }
    
        const decrement = () => {
            if (this.props.quantity > 0) {
                this.props.setQuantity(Number(this.props.quantity) - 1)
            } else return
        }

        const settings = {
            focusOnSelect: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            arrows: false,
            //centerMode: true,
            //centerPadding: '0px',
            // Callback after slide changes by swiping
            //onSwipe: '',
            // number of rows per slide in the slider, (enables grid mode)
            //rows: '',
            // number of slides to display in grid mode, this is useful with rows option
            slidesPerRow: 1,
            initialSlide: 0,
            /* responsive: [
                {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
                },
                {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
                },
                {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
                }
            ], */
            vertical: true,
            verticalSwiping: true,
            
            /* beforeChange: function(currentSlide, nextSlide) {
                console.log("before change", currentSlide, nextSlide);
            },*/
            afterChange: function(currentSlide) {
                changeSlide(currentSlide);
            }
            
        };

          const mp = Array.isArray(this.props.measure_and_price) ? this.props.measure_and_price : [];
          const safeMeasureIndex = mp.length > 0 ? Math.min(Math.max(0, Number(this.props.measureIndex) || 0), mp.length - 1) : 0;
      return (
    <>
  <div>
    <hr className="mt-0 mb-0 my-lg-2 my-md-2" />  
    <MDBCol>
        
        {/* <p className="lead fw-normal mb-2">{'title'}</p>*item?.title */}
             <div className="text-muted">
        Measure: </div><SliderContainer>
            
        
        <Slider ref={c => (this.slider = c)} {...settings}>
            {mp.length > 0 ? mp.map((type, i) => (
                <span key={i} index={i}>
                    <button className="button px-2 text-danger" onClick={this.previous}>
                      <MDBIcon fas icon="angle-up" />
                    </button>
                    {type?.measure || '—'} <span>(&#8358;{`${type?.price || 0}`})</span>
                    <button className="button px-2 text-success" onClick={this.next}>
                      <MDBIcon fas icon="angle-down" />
                    </button>
                </span>
            )) : (
                <span className="text-muted">No measures configured</span>
            )}
        </Slider>
        
        <div>{/** style={{ textAlign: "center" }} */}
    
    
  </div>
        
    </SliderContainer>
        
    </MDBCol>
  </div>

  <div>
    <hr className="mt-0 mb-0 my-lg-2 my-md-2" />

    <div className="d-flex align-items-center justify-content-center">
    <div className="px-2 text-muted">Select Quantity:
    <div className="d-flex">
        <MDBBtn color="white" className="px-2" onClick={decrement}> {/**onClick={() => props.minusItemQuantity(item)} */}
            <MDBIcon color="danger" fas icon="minus" />
        </MDBBtn>
        
        <MDBInput className="text-center text-danger" min={0} value={this.props.quantity} type="number" size="sm" disabled /> {/**value={item?.quantity} */}

        <MDBBtn color="white" className="px-2" onClick={increment}> {/**onClick={() => props.addItemQuantity(item)} */}
            <MDBIcon color="success" fas icon="plus" />
        </MDBBtn></div>
        </div>
        <hr />
            <MDBCol md="3" lg="2" xl="2" className="offset-lg-2 offset-1 border-gray-200">Amt:{/**${item?.quantity} */}
            {/*<Currency quantity={0} currency="NGN" /> {/**item?.price **/}
            <MDBTypography tag="h5" className="mb-0">&#8358;{Number(this.props.quantity) * 
                Number((mp[safeMeasureIndex] || {}).price || 0)}
        {/* <Currency quantity={0} currency="GBP" /> *item?.total */}
        </MDBTypography>
    </MDBCol>
    </div>
    
    {/* <select>
        <option>1</option>
        <option>2</option>
        <option>3</option>
        </select> */}
    </div>
  </>
  );
}
}
